class NewsletterImage extends HTMLElement {
  constructor() {
    super();

    const form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.buttonText = this.button.querySelector('.btn__text');
    this.buttonLoader = this.button.querySelector('.btn__loader');

    form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  toggleClassBetweenTwoElements(elementToAddClass, elementToRemoveClass, className) {
    elementToAddClass.classList.add(className);
    elementToRemoveClass.classList.remove(className);
  }

  onFormSubmit(event) {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(event.target).entries());

    if (!values.email || !values.list_id || !values.company_id) {
      console.error('Email, List ID or Company ID is missing', {
        email: values.email,
        listId: values.list_id,
        companyId: values.company_id,
      });
      return;
    }

    this.subscribe(values, event.target.action);
  }

  async subscribe(data, action) {
    const options = {
      method: 'POST',
      headers: {revision: '2024-07-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  location: {
                    country: data.country,
                  },
                  email: data.email
                },
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: data.list_id}}}
        }
      })
    };
    try {
      this.button.classList.add('btn--disabled');
      this.button.setAttribute('disabled', 'disabled');
      this.toggleClassBetweenTwoElements(this.buttonText, this.buttonLoader, 'hidden');

      const response = await fetch(action, options);
      if (response.ok) {
        this.showSuccessMessage();
      } else {
        const errorData = await response.json();
        this.button.classList.remove('btn--disabled');
        this.button.removeAttribute('disabled');
        console.log(errorData);
      }
    } catch (error) {
      console.error('Subscription error:', error);
    }
  }

  showSuccessMessage() {
    const successMessage = this.querySelector('.section__form--success');
    const defaultForm = this.querySelector('.section__form--default');
    if (successMessage) {
      this.classList.add('newsletter-image--is-subscribed');
      this.toggleClassBetweenTwoElements(defaultForm, successMessage, 'hidden');
    }
  }
}

customElements.define('newsletter-image', NewsletterImage);

